import { WaypointEntity } from "@src/core/entities";
import { RouteWaypointType } from '@src/features/order/pages/upsert-mission-page/entities';
import { arcSpatiumConvert } from "@src/core/extensions/arc-spatium-convert";

export const calculateDistance = (items: WaypointEntity[], altitude?: number | string) => {
  let wpCount = 0;
  let totalDistance = 0;
  return items.map((item: any, index) => {
    if (index > 0) {
      const prev = items[index - 1];

      const p1 = new window.google.maps.LatLng(Number(prev.latitude), Number(prev.longitude));
      const p2 = new window.google.maps.LatLng(Number(item.latitude), Number(item.longitude));

      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(p1, p2);

      totalDistance += distance;
    }

    wpCount += (item.type === RouteWaypointType.WAYPOINT ? 1 : 0);

    return {
      ...item,
      wpCount,
      distance: arcSpatiumConvert(totalDistance),
      altitude: Number(item.altitude) - (Number(altitude ?? 0)),
    };
  });
};